import React from "react";
import unescapeHtmlTag from "../../../../../core/utils/tools";
import MainStepsView from "../organisms/MainStepsView";


const NavigationList = ({navData, langData, navRef, slideToSubHandler}) => {

  return (
    <>
      { navData.processedNavData && navData.processedNavData.map((navigationDataObject, navObjectIdx) => {

        navRef.current[navObjectIdx] = React.createRef();
        if (navigationDataObject.isGnb) return null;

        const hasParentNav = !!navigationDataObject.parentId;

        return (
          <div
            key={navigationDataObject.id}
            id={`option_${navigationDataObject.linkPath}`}
            ref={navRef.current[navObjectIdx]}
            className={"option-h1"}
          >
            { hasParentNav && (
              <div className={"option-h1-header"}>
                <h1>{unescapeHtmlTag(navigationDataObject[langData.langName])}</h1>
              </div>
            )}

            {navigationDataObject?.navigationSteps?.map((stepObject) => {
              if (stepObject.stepType === "COLORWAY") {
                return null;
              }

              return (
                <MainStepsView
                  key={stepObject.id}
                  navigationDataObject={navigationDataObject}
                  stepObject={stepObject}
                  slideToSubHandler={slideToSubHandler}
                  hasParentNav={hasParentNav}
                />
              );
            })}
          </div>
        );
      })}
    </>
  )
}

export default NavigationList;
